import { useEffect, useState } from "react";
import { Zap, Bell, Check } from "lucide-react";
import { useLang } from "@/context/LangContext";
import Stamp from "@/components/Stamp";

// Hype countdown to the next limited merch drop (fixed target from first load).
const TARGET = Date.now() + 9 * 86400000 + 3600000 * 7;

const pad = (n) => String(n).padStart(2, "0");

const DropCountdown = () => {
  const { t } = useLang();
  const [remaining, setRemaining] = useState(TARGET - Date.now());
  const [reminded, setReminded] = useState(false);

  useEffect(() => {
    const id = setInterval(() => setRemaining(Math.max(0, TARGET - Date.now())), 1000);
    return () => clearInterval(id);
  }, []);

  const live = remaining <= 0;
  const s = Math.floor(remaining / 1000);
  const units = [
    { v: Math.floor(s / 86400), l: t.drop.days },
    { v: Math.floor((s % 86400) / 3600), l: t.drop.hours },
    { v: Math.floor((s % 3600) / 60), l: t.drop.mins },
    { v: s % 60, l: t.drop.secs },
  ];

  return (
    <section className="bg-lav border-b border-ink py-16 md:py-24 relative overflow-hidden" data-testid="drop-countdown">
      <div className="absolute right-6 md:right-16 top-6 hidden md:block opacity-90">
        <Stamp size={96} bg="bg-cream" />
      </div>

      <div className="max-w-[1100px] mx-auto px-4 md:px-8 text-center relative z-10">
        <span className="inline-flex items-center gap-2 kicker bg-cream border border-ink rounded-full px-4 py-1.5">
          <Zap className="w-3.5 h-3.5" strokeWidth={2} /> {t.drop.kicker}
        </span>
        <h2 className="display uppercase text-5xl md:text-8xl leading-[0.84] mt-5 text-brand">{live ? t.drop.live : t.drop.title}</h2>
        <p className="mt-4 max-w-xl mx-auto font-medium text-ink/70">{t.drop.sub}</p>

        <div className="mt-10 inline-grid grid-cols-4 gap-px bg-ink border border-ink" data-testid="countdown-units">
          {units.map((u, i) => (
            <div key={i} className="bg-cream w-[74px] md:w-28 py-4 md:py-6">
              <div className="display text-4xl md:text-6xl leading-none text-ink">{pad(u.v)}</div>
              <div className="kicker text-[9px] md:text-[10px] text-ink/50 mt-2">{u.l}</div>
            </div>
          ))}
        </div>

        <div>
          <button
            onClick={() => setReminded(true)}
            data-testid="drop-remind"
            className={`mt-10 h-14 px-8 text-base ${reminded ? "btn bg-cream text-ink" : "btn-primary"}`}
          >
            {reminded ? <Check className="w-5 h-5" strokeWidth={2.5} /> : <Bell className="w-5 h-5" strokeWidth={2} />}
            {reminded ? t.drop.reminded : t.drop.cta}
          </button>
        </div>
      </div>
    </section>
  );
};

export default DropCountdown;
